var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Loader'):_c('div',{},[_c('div',{staticClass:"container"},[(_vm.title.length > 0)?_c('page-title',{attrs:{"title":_vm.title}}):_vm._e(),_c('div',{staticClass:"row page-body"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }